import { DateTime } from "luxon";

export const DASHBOARD2_WEEK_PICKER_OFFSET = 4;

/** Weeks to jump when using prev/next in the week picker dialog. */
export const DASHBOARD2_WEEK_PICKER_STEP = 9;

export function buildDashboard2WeekPickerOptions(center: DateTime): DateTime[] {
  const start = center.minus({ weeks: DASHBOARD2_WEEK_PICKER_OFFSET }).startOf("week");

  return Array.from({ length: DASHBOARD2_WEEK_PICKER_OFFSET * 2 + 1 }, (_, index) =>
    start.plus({ weeks: index })
  );
}

export function isSameDashboard2Week(a: DateTime, b: DateTime): boolean {
  return a.startOf("week").toISODate() === b.startOf("week").toISODate();
}
